<template>
  <v-app>
    <div>
      <Drawer/>
    </div>
    <Navbar />
    <!-- The page canvas. Deliberately grey, not white and not the same colour
         as the cards that sit on it -- see app-css/kf-tokens.css. -->
    <v-main app style="background-color: var(--kf-canvas)">
      <Body/>
    </v-main>

    <SnakeBar></SnakeBar>
    <LogoutAlertDialog :dialog="dialog" />
  </v-app>
</template>
<script>
export default {
  components: {
    Navbar: () => import("./Navbar.vue"),
    Drawer: () => import("./Drawer.vue"),
    Body: () => import("./Body.vue"),
    SnakeBar: () => import("@/components/ui/SnakeBar.vue"),
    LogoutAlertDialog: () => import("@/components/ui/LogoutAlertDialog"),
  },
  data() {
    return {
      events: ["click", "mousemove", "mousedown", "scroll", "keypress", "load"],
      logout_timer: null,
      warning_timer: null,
      setCountDown: null,
      dialog: {
        warning_zone: true,
        countDown: 0,
      },
    };
  },
  mounted() {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);
    this.setTimer();
    this.refreshAccess();
  },
  watch: {
    /* Re-asked on navigation, not just once, so a change an admin makes while
       this person is signed in reaches them on their next page load rather
       than on their next login. */
    $route() {
      this.refreshAccess();
    },
  },
  destroyed() {
    this.events.forEach(function (event) {
      window.removeEventListener(event, this.resetTimer);
    }, this);

    // Timers are CLEARED here, not re-armed. This used to call resetTimer(),
    // which clears the two timers and then immediately calls setTimer() again
    // -- arming a fresh 15-minute logout timeout on a component that no longer
    // exists.
    clearTimeout(this.warning_timer);
    clearTimeout(this.logout_timer);
    clearTimeout(this.setCountDown);

    // Once, and with the component as `self`.
    //
    // This sat INSIDE the forEach above, so it fired once per event name --
    // six logout POSTs on every teardown. And `self` is not defined in that
    // scope, so it resolved to the global `window.self`: the request helper
    // was handed the window object where it expects the component, which is
    // what its error handlers would have written their state onto.
    this.request_POST(this, this.$urls.LOGOUT_TEAMMATE);
  },
  methods: {
    /**
     * Re-read what this user is allowed: their screens, and the filters an
     * admin has fixed for them.
     *
     * Both used to be a snapshot taken at login and kept in sessionStorage,
     * which went stale the moment an admin changed anything. Removing a
     * member's filtered view left their City and State controls hidden for the
     * rest of the session -- the restriction was gone from the database and
     * from the queryset, but the screen carried on hiding the controls.
     *
     * Failure is deliberately silent: the seeded values stay in place, which is
     * no worse than the behaviour this replaces, and a dead lookup must not
     * take down the shell every screen renders inside.
     */
    refreshAccess() {
      const self = this;
      const successHandler = (response) => {
        if (!response.data || !response.data.success) return;

        const permissions = response.data.permission_list || [];
        self.$store.dispatch("setPermissionList", permissions);
        sessionStorage.setItem("permission_list", JSON.stringify(permissions));

        const locks = response.data.view_filter_locks || {};
        self.$store.dispatch("setViewFilterLocks", locks);
        sessionStorage.setItem("view_filter_locks", JSON.stringify(locks));

        sessionStorage.setItem(
          "view_filter_demo_values",
          JSON.stringify(response.data.view_filter_demo_values || {})
        );
      };
      self.request_GET(self, self.$urls.MY_ACCESS, {}, successHandler, null,
        () => {}, () => {});
    },
    resetTimer() {
      // console.log("resetTimer")
      clearTimeout(this.warning_timer);
      clearTimeout(this.logout_timer);
      this.setTimer();
    },
    setTimer() {
      //console.log("setTimer")
      this.warning_timer = setTimeout(
        this.warningMessage,
        15 * 60 * 1000 - 15 * 1000
      );
      this.logout_timer = setTimeout(this.logoutUser, 15 * 60 * 1000);
      this.dialog.warning_zone = false;
      if (this.setCountDown) clearTimeout(this.setCountDown);
    },
    warningMessage() {
      // console.log("warningMessage")
      this.dialog.warning_zone = true;
      this.dialog.countDown = 15;
      if (this.setCountDown) clearTimeout(this.setCountDown);
      this.countDownTimer();
      //console.log("this.logout_timer=", this.logout_timer)
    },
    logoutUser() {
      localStorage.removeItem("active-tab");
      this.dialog.warning_zone = false;
      this.$router.push({ name: "login" });
      this.request_POST(self, this.$urls.LOGOUT_TEAMMATE);
    },
    countDownTimer() {
      if (this.dialog.countDown > 0) {
        this.setCountDown = setTimeout(() => {
          this.dialog.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
  },
};
</script>